export enum Routes {
  AddOn = 'addon',
  OfferingsPatch = 'accounts/offerings',
}
